// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1KNzL","signatureButtonsRight":"ModalSign_signatureButtonsRight__gpBOr"};